import Model, { attr } from '@ember-data/model'

export default class DestinationModel extends Model 
{
	@attr name;
	@attr host;
	@attr username;
	@attr path;
	@attr PEM;
	@attr accessKeyId;
	@attr secretAccessKey;
	@attr('boolean') enabled;
	
	get type()
	{
		if(this.PEM != null)
		{
			return "SCP";
		}
		if(this.accessKeyId != null)
		{
			return "S3";
		}
		
		return "";
	}
}
